import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  updateDayforceWebhook,
  type UpdateDayforceWebhookRequest,
} from 'api/admin/dayforce/updateDayforceWebhook'
import { dayforceKeys } from './keys'

export const useUpdateDayforceWebhookMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (request: UpdateDayforceWebhookRequest) =>
      updateDayforceWebhook(request),
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: dayforceKeys.webhooks(),
      })
      await queryClient.invalidateQueries({
        queryKey: dayforceKeys.webhookDetail(variables.webhookId),
      })
    },
  })
}
